// @flow

import { ACTIONS } from './constants';

export const setFeatures = (features: {}) => (dispatch: Function) => {
    dispatch({
        type: ACTIONS.FEATURES_SET,
        features
    });
};
